import {PAGE_COMPONENT_TYPES} from '../enums';

export class PageComponent {
  id: number;
  name: string;
  order: number;
  type: PAGE_COMPONENT_TYPES;
  content: any;
}
